module.exports = __webpack_public_path__ + "15acb407ee583815161ea6da5f23ab88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/northwestern_university.png
// module id = 2041
// module chunks = 0